import { SimpleOption } from '../models/simple-option';

export const FRAME_TYPES: Array<SimpleOption> = [
  {
    id: 1,
    name: 'Proste',
  },
  {
    id: 2,
    name: 'Z węgarkiem',
  },
];
